/**
 * @module app.bdc.reports.sepaCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function SepaEasyfiCtrl($scope, $window, $rootScope) {
        var self = {};
        self.client = $rootScope.order.client;

        self.IBAN = self.client.IBAN && self.client.IBAN !== '' ? self.client.IBAN.split('') : [];
        self.codeBic = self.client.codeBic && self.client.codeBic !== '' ? self.client.codeBic.split('') : [];

        /**
         * Get the date of the day
         * @return {String}
         */
        self.getDate = function getDate() {
            return moment().format('DD/MM/YYYY');
        };

        /**
         * Make a for in the view
         * @param  {int} min
         * @param  {int} max
         * @param  {int} step
         * @return {Array}
         */
        self.range = function(min, max, step) {
            step = step || 1;
            var input = [];
            for (var i = min; i <= max; i += step) {
                input.push(i);
            }
            return input;
        };

        return self;
    }

    SepaEasyfiCtrl.$inject = ['$scope', '$window', '$rootScope'];

    angular.module('app.bdc.reports.sepaEasyfiCtrl', []).controller('SepaEasyfiCtrl', SepaEasyfiCtrl);
});
